/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserRobot} from '@fortawesome/pro-duotone-svg-icons';

const SchedulerAutomatedIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserRobot} {...props} />
);

export default SchedulerAutomatedIcon;
